import { types } from "../types/types";

const initialState = {
    startDate: null,
    endDate: null,
    namePoint: null,
    data: [],
}
/**
 * Reducer function to set information 
 * @param {object} state -Information of the Redux
 * @param {object} action -Action to send information to the redux 
 */
export const printReducer = (state =initialState, action) => {
    switch (action.type) {
        case types.printSetDate:
            return{
                ...state,
                startDate: action.payload.startDate,
                endDate: action.payload.endDate,
                namePoint: action.payload.namePoint,
                data: action.payload.dataInformation,
            }
        case types.printClear:
            return {
                ...state,
                startDate: null,
                endDate: null,
                namePoint: null,
                data: [],
            }

        default:
            return state
    }

}
